import { SelectedToolbarProps } from "../../../ui/Table/Table";
import TableToolbar from "../../../ui/Table/TableToolbar";
import { Copy, PlusCircle, PlayCircle } from "../../../ui/Icon/Icon";
import GenerateArticlesFromKeywordsModal from "./GenerateArticlesFromKeywordsModal";
import { useDisclosure } from "../../../ui/util/useDisclosure";
import AddKeywordsAsDraftModal from "./AddKeywordsAsDraftModal";
import { useToast } from "../../../ui/Toast/ToastContext";

function KeywordTableToolbar({ ids }: SelectedToolbarProps) {
  const { showToast } = useToast();

  const [
    generateArticlesFromKeywordsModalOpened,
    generateArticlesFromKeywordsModal,
  ] = useDisclosure(false);
  const [addKeywordsAsDraftModalOpened, addKeywordsAsDraftModal] =
    useDisclosure(false);

  return (
    <>
      <TableToolbar
        items={[
          {
            IconComponent: PlayCircle,
            onClick: generateArticlesFromKeywordsModal.open,
            label: "Generate articles",
          },
          {
            IconComponent: PlusCircle,
            onClick: addKeywordsAsDraftModal.open,
            label: "Create draft articles",
          },
          {
            IconComponent: Copy,
            onClick: async () => {
              await navigator.clipboard.writeText(ids.join("\n"));

              showToast({
                title: "Copied to clipboard",
              });
            },
            label: "Copy keywords",
          },
        ]}
      />
      <GenerateArticlesFromKeywordsModal
        isOpen={generateArticlesFromKeywordsModalOpened}
        onClose={generateArticlesFromKeywordsModal.close}
        keywords={ids}
      />
      <AddKeywordsAsDraftModal
        isOpen={addKeywordsAsDraftModalOpened}
        onClose={addKeywordsAsDraftModal.close}
        keywords={ids}
      />
    </>
  );
}

export default KeywordTableToolbar;
